/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CommonActions, FormActionPipelines, FormFlowState } from '@gh/builder-shared';
import { CustomFieldPlacement, CustomFieldType } from '@gh/builder-shared-data';
import { EnumDictionary, getDialogInitData } from '@gh/common-shared';
import { DialogInput, getControl, getControlValue, setControlValue } from '@gh/core-ui';
import { assign } from 'lodash';
import {
  CustomFieldDetailsDialogConfig,
  CustomFieldListBusinessService,
} from '../../resources/custom-field-list-business.service';
import { CustomFieldDetails } from '../../resources/custom-field.model';
import { CustomFieldDetailsFormState } from './custom-field-details-form.service';

@Component({
  standalone: false,
  selector: 'gh-custom-field-details-dialog',
  templateUrl: 'custom-field-details-dialog.component.html',
  styleUrls: ['custom-field-details-dialog.component.scss'],
  providers: [CustomFieldListBusinessService],
  viewProviders: [CustomFieldDetailsFormState],
})
export class CustomFieldDetailsDialogComponent implements DialogInput<CustomFieldDetailsDialogConfig>, OnInit {
  placements: EnumDictionary<CustomFieldPlacement>;
  types: EnumDictionary<CustomFieldType>;
  input: CustomFieldDetailsDialogConfig;
  decimalPlaces: number[] = [1, 2, 3, 4];

  constructor(private businessService: CustomFieldListBusinessService,
              public dialogRef: MatDialogRef<CustomFieldDetailsDialogComponent>,
              @Inject(MAT_DIALOG_DATA) private dialogData: any,
              public form: CustomFieldDetailsFormState,
              private pipelines: FormActionPipelines,
              private commonActions: CommonActions) {

  }

  get title(): string {
    return this.input.id ? 'lbl_custom_field_edit' : 'lbl_custom_field_create';
  }

  ngOnInit(): void {
    const { customField, ...init } = getDialogInitData(this.dialogData);

    assign(this, init);

    this.form.build(customField);

    const customFieldId = this.input.id;
    if (customFieldId) {
      this.form.displayAdditionalFields(getControlValue(this.form.group, 'dataType'));
      if (customField.dataType === CustomFieldType.Text) {
        setControlValue(this.form.group, 'textLength', customField.digitsLength);
      }
      this.form.group.disable();
      getControl(this.form.group, 'name').enable();
      getControl(this.form.group, 'required').enable();
    }
  }

  onSubmit(): void {
    const flow = this.pipelines.process({
      execute: this.commonActions.execute((state: FormFlowState<CustomFieldDetails>) =>
        this.businessService.save(state.value)),
      finish: (state) => this.dialogRef.close(state.value),
    });

    flow.run({ form: this.form, value: this.form.submitValue });
  }

  onCancel(): void {
    this.dialogRef.close();
  }
}
